import { render, staticRenderFns } from "./ProductUpgrade.vue?vue&type=template&id=587fcaac"
import script from "./ProductUpgrade.vue?vue&type=script&lang=js"
export * from "./ProductUpgrade.vue?vue&type=script&lang=js"
import style0 from "./ProductUpgrade.vue?vue&type=style&index=0&id=587fcaac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports